<template>
  <div style="max-width: 1200px">
    <ValidationObserver ref="form">
      <form>
        <h1>活動資料</h1>
        <div class="form-group row">
          <label for="" class="col-sm-3"><span/> 活動名稱 <span class="require" v-if="formDataValidate.Name" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Name" v-slot="{ errors }" name="姓名">
              <input type="text" class="form-control" placeholder="" v-model="formData.Name" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label for="" class="col-sm-3"><span/> 備註 <span class="require" v-if="formDataValidate.Memo" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Memo" v-slot="{ errors }" name="date">
              <input type="text" class="form-control" placeholder="" v-model="formData.Memo" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>


        <h1>場次</h1>
        <a class="btn btn-primary" href="#"  @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>
        <table class="table table-hover" id="tblMain">
          <thead class="thead-light">
          <tr>
            <th class="text-center">功能</th>
            <th>場次名稱</th>
            <th>是否需先報名</th>
            <th>匯入時Excel欄</th>
            <th>報到時回覆</th>
<!--            <th>備註</th>-->
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in this.formData.EventItems" :key="index">
            <td class="text-center">
              <a class="btn btn-danger" href="#" @click="DataItem_Remove(item)"><i class="far fa-trash-alt"></i></a>
              <a class="btn btn-primary" href="#" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i> </a>
              <a class="btn btn-primary" href="#" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i> </a>
            </td>
            <td width="200px">
              <input type="text" class="form-control" placeholder="" v-model="item.Name">
            </td>
            <td width="200px">
              <label class="radio-inline"><input type="radio" :value="CheckIn_EventItemType_Open" v-model="item.Type">開放型</label>
              <label class="radio-inline"><input type="radio" :value="CheckIn_EventItemType_NeedReg" v-model="item.Type">需先報名</label>
            </td>

            <td width="200px">

              <select class="form-control" v-if="item.Type===CheckIn_EventItemType_NeedReg" v-model="item.ExcelColumn">
                <option></option>
                <option value="J">J</option>
                <option value="K">K</option>
                <option value="L">L</option>
                <option value="M">M</option>
                <option value="N">N</option>
                <option value="O">O</option>
                <option value="P">P</option>
                <option value="Q">Q</option>
                <option value="R">R</option>
                <option value="S">S</option>
              </select>

              <div v-if="item.Type===CheckIn_EventItemType_NeedReg"> 由excel的那一欄，匯入社員是否有報名的資訊</div>

            </td>

            <td>
                問題1 問題<input type="text" class="form-control"  placeholder="" v-model="item.Question1">
                問題1 選項<input type="text" class="form-control"  placeholder="以逗號分隔，例如 葷,素" v-model="item.Question1Options">
              <hr>
                問題2 問題<input type="text" class="form-control"  placeholder="" v-model="item.Question2">
                問題2 選項<input type="text" class="form-control"  placeholder="以逗號分隔，例如 葷,素" v-model="item.Question2Options">
              <hr>
                問題3 問題<input type="text" class="form-control"  placeholder="" v-model="item.Question3">
                問題3 選項<input type="text" class="form-control"  placeholder="以逗號分隔，例如 葷,素" v-model="item.Question3Options">
            </td>
<!--            <td >-->
<!--              <textarea class="form-control" rows="3" v-model="item.Memo"></textarea>-->
<!--            </td>-->
          </tr>

          </tbody>
        </table>
        <div class="form-group row">
          <div class="col-sm-10">
            <a class="btn btn-primary mybutton" @click.prevent="submit">確定</a>
            <!--            <a class="btn btn-primary mybutton" @click.prevent="clone">複製到下一筆功能</a>-->
            <a class="btn btn-danger mybutton" @click.prevent="reset">取消</a>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>/**

 **/
import util from "@/util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import veeHelper from "@/util/veeHelper";
import arrayUtil from "@/util/arrayUtil";
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg} from "@/views/checkInAdmin/js/checkInDeclare";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";

let returnRouter="CheckInAdminEventIndex";

export default {
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      SystemId: "",
      type: "",
      formData: {
        Name: "",
        Memo:"",
        EventItems:[],
      },
      formDataValidate: {
        Name: "required",
        Memo:"",
      },
    };
  },
  watch:{
    '$route'(to,from){// eslint-disable-line
      this.SystemId=this.$route.query.SystemId
      this.type=this.$route.query.type

      this.getItem()
      this.$forceUpdate();
    },
  },
  methods: {
    getItem:function(){
      let that=this

      let loader=util.ShowLoading(this);

      if (this.SystemId){
        apiCheckIn.api_Event_Get(this.SystemId).then((data)=>{
          that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,this.formData);

          util.HideLoading(loader);
        });
      }else{
        util.HideLoading(loader);
      }

    },
    submit:function(){
      let that=this
      let router=this.$router


      this.$refs.form.validateWithInfo().then(({ isValid, errors }) => {
        if (!isValid) {
          let errorMsg=veeHelper.VeeGetErrorMsgAllStr(errors);
          util.ShowMessage('部分資料未填寫完整'  +"<br/>" +errorMsg)
          return;
        }else{

          //---------------------------------------
          apiCheckIn.api_Event_Save(that.SystemId,that.formData).then(()=>{
            util.ShowMessage('儲存成功')
            router.push({ name: returnRouter, query: { type: that.type }})
          })
          //---------------------------------------
          // Wait until the models are updated in the UI
          that.$nextTick(() => {
            that.$refs.form.reset();
          });
        }
      });

    },
    reset:function(){
      this.$router.push({ name: returnRouter, query: { type: this.type }})
    },

    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.SystemId,this.formData.EventItems,"SystemId","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.SystemId,this.formData.EventItems,"SystemId","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        SystemId:"",
        Name:"",
        Type:CheckIn_EventItemType_Open,
        ExcelColumn:"",
        Memo:"",
        OrderKey:"999",
        Question1:"",
        Question1Options:"",
        Question2:"",
        Question2Options:"",
        Question3:"",
        Question3Options:"",
      };
      newItem.SystemId=util.uuid();

      arrayUtil.orderAppendLast(newItem,this.formData.EventItems,"OrderKey")
    },
    DataItem_Insert(currentItem){
      let newItem={
        SystemId:"",
        Name:"",
        Type:CheckIn_EventItemType_Open,
        ExcelColumn:"",
        Memo:"",
        OrderKey:"999",
        Question1:"",
        Question1Options:"",
        Question2:"",
        Question2Options:"",
        Question3:"",
        Question3Options:"",
      };
      newItem.SystemId=util.uuid();

      arrayUtil.orderInsert(newItem,currentItem,this.formData.EventItems,"SystemId","OrderKey")
    },
    DataItem_Remove(item){
      this.formData.EventItems= this.formData.EventItems.filter(s => s.SystemId !==item.SystemId);
    },

  },
  mounted() {
    this.SystemId=this.$route.query.SystemId
    this.type=this.$route.query.type

    this.getItem()
  },
}
</script>

<style scoped>

</style>
